import { rem } from "polished";
import styled from "styled-components";

import { BlockPaddingWrapper } from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { Circle } from "@/components/editor/themes/hazel/shared/circle-component";
import { ColorLabels } from "@/components/editor/utils/colors";

export const VideoAndParagraphList = withViewportStyle("div")`
  position: relative;  
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${rem(112)};

  ${(props) => props.$viewport.tablet` 
    grid-gap: ${rem(24)};`}

  ${(props) => props.$viewport.mobile`
    grid-template-columns: auto;`}
`;

export const PaddingWrapper = withViewportStyle(BlockPaddingWrapper)`
  padding: ${rem(80)} ${rem(24)};
  
  ${(props) => props.$viewport.mobile` 
    padding: ${rem(40)} ${rem(16)};`}
`;

export const StyledCircleContainer = withViewportStyle("div")`
  position: absolute;
  bottom: -10%;
  right: ${rem(-60)};

  ${(props) => props.$viewport.tablet`
    display: none;
  `}
`;

export const StyledCircle = styled(Circle).attrs((props) => ({
  half: true,
  color: props.theme.colors[ColorLabels.VISUALS_2],
  size: 200,
  rotate: 180,
}))`
  display: inline-block;
`;
